import { Box } from '@cmg/design-system';
import React from 'react';

type Props = {
  children?: React.ReactNode;
};

const OfferingSetupPage: React.FC<Props> = ({ children }) => {
  return (
    <Box bgcolor={theme => theme.palette.background.paper} width="100%">
      {children}
    </Box>
  );
};

export default OfferingSetupPage;
